import React, { useMemo } from "react";
import { View, ActivityIndicator, StyleSheet, ViewProps } from "react-native";
import { useTheme } from "../theme";
import { ThemeColors } from "../theme/types";

interface LoaderProps extends ViewProps {
  testID?: string;
}

const Loader: React.FC<LoaderProps> = ({ testID, ...props }) => {
  const { colors, resolvedTheme } = useTheme();
  const isDarkTheme = resolvedTheme === "dark";
  const styles = useMemo(() => createStyles(colors, isDarkTheme), [colors, isDarkTheme]);
  return (
    <View testID={testID} style={styles.loaderContainer} {...props}>
      <ActivityIndicator size="large" color={colors.text.primary} />
    </View>
  );
};

const createStyles = (colors: ThemeColors, isDarkTheme: boolean) =>
  StyleSheet.create({
    loaderContainer: {
      position: "absolute", // Full-screen overlay
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: isDarkTheme
        ? "rgba(0, 0, 0, 0.85)"
        : "rgba(255, 255, 255, 0.8)",
      zIndex: 1000, // Ensure it appears above other components
      overflow: "hidden", // Prevent content from overflowing
    },
  });

export default Loader;
